import React, { useEffect } from "react";
import "./assets/scss/themes.scss";

import Route from "./Routes";
import { onMessage } from "firebase/messaging";
import { messaging } from "./firebase/firebase-config";

function useFirebaseForegroundMessages() {
  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("📩 Foreground notification received:", payload);

      new Notification(payload.notification.title, {
        body: payload.notification.body,
        icon: payload.notification.icon || "/favicon.ico",
      });
    });

    return unsubscribe;
  }, []);
}

function App() {
  useEffect(() => {
    import("./firebase/fcmService").then(
      ({ requestFirebaseNotificationPermission }) => {
        requestFirebaseNotificationPermission().then((token) => {
          console.log("✅ Web push token for testing:", token);
        });
      }
    );
  }, []);
  useFirebaseForegroundMessages();
  return (
    <React.Fragment>
      <Route />
    </React.Fragment>
  );
}

export default App;
